import React from 'react';
import shortId from 'short-id';
import { Label } from 'reactstrap';

const withLabel = Input => ({ label, ...props }) => {
  const id = shortId.generate();
  return (
    <React.Fragment>
      <Label htmlFor={id}>{label}</Label>
      <Input {...props} id={id} label={label} />
    </React.Fragment>
  );
};

export default withLabel;


// WEBPACK FOOTER //
// ./src/components/hocs/withLabel.jsx